export default "__VITE_ASSET__CtsBT$93__"